import React from "react";
import styles from "./NoResults.module.css";

const NoResults = ({ message = "No results found." }) => (
  <div className={styles.noResults}>{message}</div>
);

export default NoResults;